import React, {type PropsWithChildren, isValidElement} from 'react'

import styles from './TokenList.module.css'

/**
 * A styled wrapper for a row of tokens in a search result, such as the list of topics associated with a repo.
 */
export default function TokenList({children}: PropsWithChildren) {
  // Filter out falsy children to avoid wrapping `null` or `false` in a div.
  // eslint-disable-next-line @eslint-react/no-children-to-array
  const childrenArray = React.Children.toArray(children).filter(child => !!child)
  return (
    <div className={styles.tokenList}>
      {childrenArray.map((child, i) => {
        const childKey = isValidElement(child) ? child.key : i
        return <div key={childKey}>{child}</div>
      })}
    </div>
  )
}
